export const moduleConfig = {
    entityKey: 'metering-records',
    basePath: '/metering-records',
    titles: {
        singular: 'Metering Record',
        plural: 'Metering Records'
    }
}
